import React from 'react';
import { motion } from 'framer-motion';
type Props = {
  children: React.ReactNode;
  className?: string;
  id?: string;
};
export function Section({
  children,
  className = '',
  id
}: Props) {
  return <section id={id} className={`w-full px-6 md:px-10 lg:px-16 ${className}`} data-id="element-287" data-mp="3fwx3ob7a24d9">
      <div className="mx-auto max-w-7xl" data-id="element-288" data-mp="3kv8a0byd5wqq">{children}</div>
    </section>;
}
export function Reveal({
  children,
  delay = 0,
  className = ''
}: {
  children: React.ReactNode;
  delay?: number;
  className?: string;
}) {
  return <motion.div initial={{
    opacity: 0,
    y: 24
  }} whileInView={{
    opacity: 1,
    y: 0
  }} viewport={{
    once: true,
    margin: '-80px'
  }} transition={{
    duration: 0.7,
    delay,
    ease: [0.22, 1, 0.36, 1]
  }} className={className} data-id="element-289" data-mp="hdq1s3eoinps">
      {children}
    </motion.div>;
}
export function Eyebrow({
  children
}: {
  children: React.ReactNode;
}) {
  return <span className="inline-flex items-center gap-2 text-xs font-medium uppercase tracking-[0.28em] text-sage" data-id="element-290" data-mp="104zf6nrklwmn">
      <span className="h-px w-6 bg-sage/60" data-id="element-291" data-mp="2zk24hnwun4ee" />
      {children}
    </span>;
}